const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 454.69 221.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_22",
    "data-name": "Layer 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_24",
    "data-name": "Layer 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.09,39.58a5.17,5.17,0,1,1,5.16-5.16A5.17,5.17,0,0,1,171.09,39.58Zm0-9.13a4,4,0,1,0,4,4A4,4,0,0,0,171.09,30.45Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3,180.38a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,65.3,180.38Zm0-6.09a2.45,2.45,0,1,0,2.44,2.45A2.45,2.45,0,0,0,65.3,174.29Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.43,176.57a3.64,3.64,0,1,1,3.64-3.64A3.64,3.64,0,0,1,375.43,176.57Zm0-6.08a2.44,2.44,0,1,0,2.44,2.44A2.44,2.44,0,0,0,375.43,170.49Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.85,33.4a.6.6,0,0,1-.6-.6V27.67a.6.6,0,0,1,.6-.6.6.6,0,0,1,.6.6V32.8A.6.6,0,0,1,117.85,33.4Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.45,30.69h-5.13a.6.6,0,1,1,0-1.2h5.13a.6.6,0,0,1,0,1.2Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,175.08a.6.6,0,0,1-.6-.6v-5.13a.6.6,0,1,1,1.2,0v5.13A.6.6,0,0,1,200,175.08Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,172.38h-5.13a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6h5.13a.6.6,0,0,1,.6.6A.6.6,0,0,1,202.58,172.38Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.39,106.91a.6.6,0,0,1-.6-.6v-5.13a.6.6,0,0,1,1.2,0v5.13A.6.6,0,0,1,423.39,106.91Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,104.2h-5.13a.6.6,0,0,1-.6-.6.6.6,0,0,1,.6-.6H426a.6.6,0,0,1,.6.6A.6.6,0,0,1,426,104.2Z",
    style: {
      fill: "#d6ddeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_32",
    "data-name": "Layer 32"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "44.97 99.16 45.82 109.19 91.29 125.71 96.24 124.04 79.57 110.74",
    style: {
      fill: "#e8ebee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,163.67a28.27,28.27,0,0,0,4.19,2.5c.76.12-2.67-4.32-2.67-4.32",
    style: {
      fill: "#e0e5ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,131.22a18,18,0,0,1,0-2.86c.15-.45,4-13.8,4-13.8L117,104.05l4.27,1,10,2,3.9-.23L133.38,120l.45,11.48,1.95,11.71,3.53,9.07,3.75,5,6.08,4.12,4.73.83s3.83.15,4.13.07,5.55-1.12,6-1.12,6.15-3.75,6.15-3.75l8.1-6.76s5.11-7.65,5.41-7.95,5.62-12.61,6-13.36,4.65-19.35,4.65-19.35l1.13,3.6-.9,8.25-3.3,13.58-7.36,13.28L178,156.88l-7,5.47-10.51,4.88-9.68,2.93h-8.4l-8.86-1-8.18-2.78",
    style: {
      fill: "#e0e5ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.15,137.5c0-.23,1.61-4.75,1.61-4.75l5-5,9.67-3.46,15.5-1.38,7.06-.07,6.6.84,3.91,8,1.53,12.2-2.15,10.82-5.21,9.21L116.21,169l-5.53,2.23-5.6,1.23-7.83-1.31L90,167.81l-3.45-4.91-.85-3.6,1.15-.85L94,158.3l-8.44-5.6-6.37-7.29L78,140l-.15-1.85",
    style: {
      fill: "#e0e5ee"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 263.4,
    cy: 200.93,
    rx: 162.45,
    ry: 12.3,
    style: {
      fill: "#e8ebee",
      opacity: 0.56
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "123.57 92.66 113.34 82.02 103.11 82.28 99.43 83.88 103.66 85.21",
    style: {
      fill: "#e8ebee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.88,124.26S72.36,83.36,37.37,83L29.29,93.89s52.29,13.36,78.82,42.51",
    style: {
      fill: "#e0e5ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.51,84.19c29.94,1.16,59.76,29.75,68.22,38.5.17,0,.32,0,.5,0a4.54,4.54,0,0,1,1.62.3l.11-.09c-6.67-7.08-38.63-39.18-70.79-40.17l-.4,0L28.84,94.77l1,.3c.48.15,42.48,13.14,64.46,29.41a4.58,4.58,0,0,1,1.93-.44C76.08,108.5,38.18,96.12,31.3,94Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.66,85.73l3.38,2.4,7.46,10,3.94,6.4,3.63,8.26,1.05,4.31-7.52-5.24,1.17,7.82-6.89-8.93.06-5.79s-2.34-8.8-2.4-9.17-2.71-8-2.71-8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.56,79.54c-2.94.56-5.87,1.25-8.78,1.9-1.39.31-2.77.67-4.12,1.09l.6-1.19L95.44,67l8.22-5.65,2.48-1.2,4.63,5.14,3,6.5-.6,3.86-.92,2.77a1.85,1.85,0,0,0-.82-.21H102.7a1.77,1.77,0,0,0-.89.24,1.46,1.46,0,0,0-.22,0,17,17,0,0,0-3.89.44A28.51,28.51,0,0,0,94.56,79.54Z",
    style: {
      fill: "#e0e5ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,59.62,154.4,64.5l-2.28,6.33.17,4.31L153.91,80l4.23,5.44,6.1,4.56s1.21-1.39,1.62-1.8,5-3,5.44-3.25,4-1.78,4-1.78,7.15.56,7.4.56l4.39.17L182,76.77l-6.26-2.2-1.79-3.74h2.44l-2.68-3.16-10.48-6.42L159,59.13",
    style: {
      fill: "#e8ebee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,88s3.41-1.14,4.14-1.54,5.37-1.87,5.61-2a39.69,39.69,0,0,1,5.2-.65c.81,0,9.18.25,9.18.25l5.94.57,9.34,3.25,7.8,3.65,6.91,2.28,5.36,1.79,5.61.24,3.57.16,4.55-1,8.13-2.36,3.33-2L162,95.46,155.62,101l-5.37,3.25L145,106.35l-8.37,1.13-11.13-1.13-9.26-2.85-7.72-3L101.34,97a20.7,20.7,0,0,0-2.28-2.44c-.33-.08-3.58-2.92-3.58-2.92s-4-1-4.22-1.14-8-2-8-2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,84.3l-6.81-1-5.51.27c-.21,0-3.95,1.23-4.16,1.23s-4.08,2.58-4.08,2.58a23.55,23.55,0,0,0-1.64,2.39c0,.2-1,3.33-1,3.33l.41,3.48.75,2.92s1.56,2.8,1.63,3,4.91,4.77,4.91,4.77l5.1,2.45,5,1.91s6,.4,6.2.4a35.87,35.87,0,0,0,3.88,0c.21-.13,2.45-1.22,2.45-1.22a16.66,16.66,0,0,0,.68-2.32c0-.41-1-6.13-1-6.87s-2.18-7.9-2.31-8.52-3.41-8.44-3.41-8.44",
    style: {
      fill: "#f3f6fb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "173.93 70.85 175.59 74.69 186.77 77.34 187.6 71.47",
    style: {
      fill: "#e0e5ee"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 96.16,
    r: 7.93,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.13,
    cy: 96.21,
    r: 4.67,
    style: {
      fill: "#cdd3dc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.32,82.5l8.87-13.44L203,51.88l1.24-5.82,1.67.69,2.63,6.37v8.32L206.41,70l4.44-5.53,7.2-10,2.91-8,1.39.56,1.94,5.4L223,58.67l-2.77,6.65-4.18,8-4.15,6h2.19l6.81-2.66,13.29-10,.24,3L233,75.93l-2.74,5.48,1.1,2.5L230.56,89l-3.29,5.16-12,11.19.24.93s2.27.4,2.5.47,3.13,1.57,3.13,1.57l.47,2.66-1,4.53-5.32,6-9.07,4.53-7.74,2.27-5.4.47,1.41-8,.62-8.84,6.42,8.06-1-8.45,8.14,5.48s-3.92-10.25-4-10.56-6.18-9.7-6.18-9.7-6.73-8.45-6.89-8.68-5.39-5.32-5.39-5.32",
    style: {
      fill: "#e0e5ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,92.54a6.55,6.55,0,0,0-.91-.83c-.34-.28-.67-.57-1-.89s-.61-.69-.93-1a10.77,10.77,0,0,0-.91-.73,5,5,0,0,0-.5-.41c-.14-.11-.31-.19-.44-.3a1.59,1.59,0,0,0-.13-.13c.32,0,.64.06,1,.06.66,0,1.31,0,2,.08a10.38,10.38,0,0,0,1.93-.06,5,5,0,0,0,1.48-.26l.13.06a26.17,26.17,0,0,0,4,1.39c1.39.37,2.81.68,4.21,1a21.72,21.72,0,0,0,4.31.74c1.49.07,3,0,4.48.22a23.31,23.31,0,0,0,4.5.13c2.27-.15,4.54-.51,6.81-.63l-4,2.29s-4.89,1.66-5.42,1.89-5.2,1-5.2,1-5.41.11-5.73,0-4.24-.67-4.77-.67A36.77,36.77,0,0,1,132.78,94,4.93,4.93,0,0,0,132,92.54Z",
    style: {
      fill: "#f3f6fb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.28,82.13c.76,0,1.51,0,2.28,0q1.89,0,3.78.09a21.45,21.45,0,0,1,7.13,1.25.82.82,0,0,0,.26,0c1,.33,1.92.62,2.87,1,1.42.54,2.62,1.46,4,2,.69.28,1.39.49,2.08.74l.17.07-.22,0a11.75,11.75,0,0,1-1.78,0c-.62,0-1.23,0-1.85-.06s-1.25-.12-1.88-.13a.49.49,0,0,0-.27.9.46.46,0,0,0,.24.48c.27.13.43.47.67.65s.55.4.82.62a10,10,0,0,1,.88.7c.29.3.55.63.84.94s.61.58.93.86a8.81,8.81,0,0,1,.93.79,2.78,2.78,0,0,1,.26.34,2.16,2.16,0,0,0-.51-.15c-.43,0-6.58-2.34-6.58-2.34l-7.22-4.22s-7-2.56-7.64-2.56a3.5,3.5,0,0,1-1.48-.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.51,59.57l3.08-1.38L116.7,55,128,52.88l7.85.22,9.55,1.38,12,3.39,1.8,1.7-2.44,2.65s-2.76,3.93-3.07,4.35S152,70,152,70s.32,5.83.43,6.26,2,4.14,2.23,4.56,4.67,6,5,6.26l4.57,3-.36.2c-3.27-.09-6.5.58-9.76.67-1.48,0-2.91-.16-4.39-.26s-3-.06-4.48-.19a31.83,31.83,0,0,1-4.42-.92c-1.41-.32-2.82-.63-4.21-1s-2.62-1-3.93-1.52a28.46,28.46,0,0,1-3.91-1.51,18,18,0,0,0-3.51-1.61c-.58-.2-1.17-.38-1.76-.57a.87.87,0,0,0-.58-.93c-.48-.18-1-.32-1.48-.46a.78.78,0,0,0-.78-.52c-.12,0-.23,0-.35,0a.8.8,0,0,0-.71-.67.83.83,0,0,0-.6-.24.81.81,0,0,0-.43.12,42.9,42.9,0,0,0-6.19-1.78l.06-.09,1.06-4.46-.1-2.86L112.13,67l-4.56-5.73-2.44-.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.62 107.23 133.37 120.89 134 135 137.32 148.12 140.91 154.85 147.74 160.43 152.77 162.04 157.18 162.31 160.77 162.13 168.41 158.9 174.43 154.94 179.82 148.03 184.85 140.48 188.71 131.04 191.23 123.41 192.49 116.31 193.66 110.38 191.32 112.08 184.94 112.17 177.3 110.56 169.04 105.71 165.17 100.14 163.91 94.47 163.82 91.51 161.58 95.55 155.47 101.66 150.62 103.73 147.2 105.44 143.97 106.25 139.3 107.05 134.62 107.23",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.56,104.94a9,9,0,1,1,9-9A9,9,0,0,1,176.56,104.94Zm0-16.64A7.67,7.67,0,1,0,184.23,96,7.68,7.68,0,0,0,176.56,88.3Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.52,87c.2-.14.42-.26.63-.38.52-.24,1.15-.51,1.88-.79A7.81,7.81,0,0,0,84.29,85l1-.32c.41-.09.81-.19,1.21-.32l0,0c7.34-1.91,19-2.86,32.68,3.58,23.15,10.93,30.72,9.1,45,1.55l.61,1.15c-7.27,3.86-13,6.27-19.86,6.27-6.73,0-14.62-2.29-26.27-7.79C96.07,78.44,79.2,88.54,79,88.64l-.58-.93C78.81,87.47,79.16,87.22,79.52,87Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.12,77.8a.43.43,0,0,0-.16,0,10.64,10.64,0,0,0,1-5.11c-.44-7.07-8.07-12.26-8.15-12.32l.73-1.08c.34.23,8.24,5.62,8.72,13.32a11.82,11.82,0,0,1-1,5.57A2.07,2.07,0,0,0,112.12,77.8Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8,101.3A5.23,5.23,0,1,1,182,96.08,5.23,5.23,0,0,1,176.8,101.3Zm0-9.14a3.92,3.92,0,1,0,3.91,3.92A3.93,3.93,0,0,0,176.8,92.16Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91,96.4a.65.65,0,0,1-.36-1.2C228.73,84.66,233,76.92,233.81,72.28a7.73,7.73,0,0,0-.48-4.64c-15.39,13.74-21.41,12.6-21.66,12.54l-.95-.21.56-.8C223,62.47,224.12,54.08,223,50a5.76,5.76,0,0,0-1.7-2.86c-2.17,9.66-13.91,22.87-14.42,23.45l-1.93,2.15.81-2.77c4.88-16.64.67-21.84-1.2-23.25C203.23,59.27,187.63,82,187,83a.65.65,0,1,1-1.07-.74c.17-.24,17-24.72,17.4-36.65l0-.87.82.27c.37.12,8.51,3,3.61,22.48,3.62-4.4,11.27-14.4,12.41-21.52l.13-.81.75.3a6.16,6.16,0,0,1,3.15,4.1c1.26,4.28.33,12.82-11.08,29.31,2.35-.37,8.52-2.38,20-12.7l.51-.47.44.54c.07.09,1.74,2.21,1.11,6.19-.77,4.91-5.2,13-21.85,23.88A.58.58,0,0,1,212.91,96.4Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.81,108.44a.65.65,0,0,1-.37-1.18c14.77-10.44,18.45-17.42,18.94-21.44a5,5,0,0,0-.67-3.66.65.65,0,0,1,1-.85,6.14,6.14,0,0,1,1,4.67c-.52,4.28-4.32,11.63-19.48,22.34A.66.66,0,0,1,211.81,108.44Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.93,129.35l-.19-1.29.81-.11c13.87-1.07,22.13-8.1,22.22-8.17,4.31-4.32,6.14-7.79,5.26-10-1.15-2.89-6.55-3.09-6.61-3.09l0-1.3c.26,0,6.32.22,7.78,3.9,1.11,2.78-.77,6.63-5.59,11.44-.38.33-8.68,7.41-23,8.51Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.21,200.21a.64.64,0,0,1-.64-.53.64.64,0,0,1,.52-.76L147.54,195a.65.65,0,0,1,.76.52.65.65,0,0,1-.52.76l-21.46,3.94Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.31,197.36a.44.44,0,0,1-.19,0l-11.38-3.5a.65.65,0,1,1,.38-1.24l11.39,3.5a.65.65,0,0,1-.2,1.27Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,191.66a.59.59,0,0,1-.12-.37l-.37-24.3.15-1a.65.65,0,0,1,1.28.22l-.14.83.38,24.18a.64.64,0,0,1-.64.66A.63.63,0,0,1,165,191.66Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.59,190.66a.61.61,0,0,1-.11-.48.65.65,0,0,1,.75-.54l21.51,3.62a.65.65,0,1,1-.21,1.28L159,190.93A.66.66,0,0,1,158.59,190.66Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,191.66a.51.51,0,0,1-.09-.18.65.65,0,0,1,.42-.82L176.62,187a.65.65,0,1,1,.4,1.24l-11.33,3.67A.64.64,0,0,1,165,191.66Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.51,109.87a15.28,15.28,0,0,1-1.76.67,23.29,23.29,0,0,1-13.93-.39C169,107,162.76,98.76,165,91.88c1.07-3.3,3.91-5.81,8-7.09A20.28,20.28,0,0,1,179,83.9a25.69,25.69,0,0,1,7.86,1.28c.53.17,1,.36,1.54.56a9.63,9.63,0,0,1-.55-1.59c-.2-.06-.39-.14-.58-.21a24.61,24.61,0,0,0-14.72-.4c-4.51,1.41-7.65,4.23-8.85,7.93-2.45,7.57,4.14,16.5,14.68,19.92a27.08,27.08,0,0,0,8.27,1.34,21.59,21.59,0,0,0,6.45-.94c.5-.16,1-.34,1.44-.53A8,8,0,0,1,194.51,109.87Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,78.27l-11.95-3-2.42-5.23,15.5,1Zm-11-4.1,10,2.49.69-4.38L175,71.49Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.58,122.57l-8.08-10.94,1-.77,5.17,7-.89-7.57,7.39,5.12-2.13-6C199,95.14,187.61,85.1,187.5,85l-.84-.61.76-1,.89.64c.16.14,11.77,10.36,18,25l3.5,9.81L201.45,113Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.21,107.17a12.6,12.6,0,0,0-.32-1.35l-.07-.13-.07-.07s0,0,0-.05l-.4-.06c-8.13,58.8-38.59,56.18-38.93,56.15a18.86,18.86,0,0,1-14-7.46c-11.34-14.73-5.84-46.2-5.78-46.51l-1.29-.23c-.23,1.31-5.65,32.35,6,47.54a20.09,20.09,0,0,0,14.89,8s.32,0,.83,0c5,0,31.39-2.6,39.27-55.56A.94.94,0,0,1,195.21,107.17Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.89,59.06a.46.46,0,0,1-.37.18.49.49,0,0,1-.47-.61,8.11,8.11,0,0,1-1.93-.81,68,68,0,0,0-14.65-4.38C108.55,47.21,88.29,71.71,81.1,82.71c.65-.21,1.3-.41,2-.59,7.69-11.26,27.3-33.27,60.18-27.39a66.37,66.37,0,0,1,14.93,4.5c-5,5.12-7.29,10.3-6.68,15.42,1,8.66,9.82,14.31,12.17,15.67-4.59,8.94-11.84,14.24-21.56,15.74-18.73,2.91-39.76-8.91-43-12.3-4.79-5-15.89-6.06-19.35-6.27.14-.26.33-.59.54-.95-.26.14-.52.29-.76.45-.51.33-1,.69-1.52,1l-.33.68,1,0c.14,0,14.24.49,19.47,5.93,2.2,2.28,9.19,6.42,18,9.45a3.86,3.86,0,0,1,1.26.46l0,0c7.72,2.51,16.66,4.08,24.9,2.8,10.36-1.6,18-7.33,22.81-17l.28-.56-.57-.3c-.11-.06-10.95-5.86-12-15-.57-4.83,1.67-9.76,6.66-14.69a63,63,0,0,1,16.69,11.24.65.65,0,0,1,.2,0H178A63.91,63.91,0,0,0,160.89,59.06Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.59,89a58.56,58.56,0,0,0-8-12.77l-.12,0-.15-.08-.1,0a.66.66,0,0,1-.37,0c-.42-.07-.82-.19-1.23-.28a57.79,57.79,0,0,1,8.75,13.69c8.85,19.49,6.3,40.08-7.6,61.17a35.28,35.28,0,0,1-10.11,10.18c-8.16,5.38-24.83,13.23-44.81,5.44a18.93,18.93,0,0,1-1.9-1,3.26,3.26,0,0,1-.74,1.07,19.39,19.39,0,0,0,2.16,1.12,47.86,47.86,0,0,0,17.52,3.37c12.55,0,22.65-5.08,28.49-8.93A36.58,36.58,0,0,0,182.9,151.4C196.86,130.21,199.52,108.62,190.59,89Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.51,
    cy: 95.88,
    r: 1.25,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.92,78.8c-3.15.43-6.3,1.1-9.42,1.8a38.36,38.36,0,0,1,22.75-3,31.56,31.56,0,0,1,11.13,4.27C146,95.58,163.86,89.52,164,89.46l.4,1.13a36.82,36.82,0,0,1-11,1.45c-7.57,0-18.43-1.76-30.64-9.14a30.52,30.52,0,0,0-10.71-4.12,38.06,38.06,0,0,0-13,0Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.54,86.38a6.94,6.94,0,0,1,.83-.37A21.16,21.16,0,0,0,84,85.18c-1.08.74-2.16,1.54-3.23,2.44L80,86.7C80.18,86.59,80.35,86.48,80.54,86.38Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.65,85.63l.4-1.13a72.26,72.26,0,0,0-37.38-1L91,84.62A70.91,70.91,0,0,1,127.65,85.63Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.08,78.82,81,83.55l.13-.84a106.77,106.77,0,0,1,18.39-5.18",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.34,83.24s-21.3-5.71-42.8,3.14c0,0-3,1.54-2.87,2.33l2-.53,4.2-2.36,13-2.84,3.15.43s12-.92,16.5-.13-.18-.87-.18-.87",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.94,86.52l-.68-1s-8.28-2.44-13-2.64-.88.54-.83.69a5.65,5.65,0,0,0,1.41.34",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.35,110.29c-.2.08-.39.17-.6.24a23.29,23.29,0,0,1-13.93-.4C169,106.94,162.76,98.74,165,91.86c1.07-3.29,3.91-5.81,8-7.09a20.27,20.27,0,0,1,6.06-.88A25.26,25.26,0,0,1,186.23,85a2.39,2.39,0,0,1-.22-1.42,24.1,24.1,0,0,0-13.42,0c-4.51,1.4-7.65,4.22-8.85,7.93-2.45,7.56,4.14,16.49,14.68,19.91a27.08,27.08,0,0,0,8.27,1.34,21.59,21.59,0,0,0,6.45-.94l.07,0A2.33,2.33,0,0,1,193.35,110.29Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.25,59.85l-1.36-.79s-2.68-1.3-3.69-1.62,1.41,1.48,1.41,1.48l1.19.32",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "145.96 53.94 141.68 53.17 142.21 54.15 144.41 54.59 145.75 54.7",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1,87.6a.44.44,0,0,0,.05.15.29.29,0,0,0,.13.14.28.28,0,0,0,.17.09.9.9,0,0,0,.16,0l-.06.9-8.29-.67,6.9,5.72-.73,1-10-8.31Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.66,
    y: 169.84,
    width: 1.3,
    height: 26.88,
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19,173.26a21,21,0,0,1-13.39-4.77c-3.8-3.08-5.58-6.62-5.63-8.61a2,2,0,0,1,.81-1.71c1.09-.8,3.24-.73,5.36-.39-10.68-6.27-13.78-15.22-13.93-15.65l0-.1c-.72-4.75.45-8.74,3.48-11.86,10.83-11.15,41.68-7.52,43-7.36l.31,0,.15.28c9.37,17.8,4.57,31.54-1.11,39.94a23.22,23.22,0,0,1-15.75,10A22.69,22.69,0,0,1,104.19,173.26ZM88.62,158.73a3.44,3.44,0,0,0-1.93.41.77.77,0,0,0-.32.71c0,1.44,1.45,4.67,5.18,7.71a20,20,0,0,0,15.73,4.27,22,22,0,0,0,14.94-9.44c5.46-8.07,10.08-21.28,1.18-38.42-3.3-.36-31.81-3.11-41.67,7a12.15,12.15,0,0,0-3.17,10.78c.3.81,4.52,11.81,18.42,17.43l-.41,1.13A29.21,29.21,0,0,0,88.62,158.73Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "121.7 164.86 124.41 166.59 125 165.32 122.59 163.72",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.33,126.1c-10.7-5.37-43.49-15.94-43.82-16l-.38-.12-.9-10.16,1.19-.11.84,9.37c3.71,1.2,33.45,10.89,43.61,16Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,103.26c-1.21,1.91-7.71,12.36-8.82,19.32a4.78,4.78,0,0,1,.68-.06,5.05,5.05,0,0,1,.68.06c1.17-6.78,7.73-17.27,8.68-18.76A3.9,3.9,0,0,1,117,103.26Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,33.85v126.2l1.77,2.59,2.72.71,82.55.23-.12,21.94-30.66.24-3.19,1.65-2.71,3.53-.35,5,2.24,3.42,3.89,2.49H353.4l2.83-1.43,3.06-3.42.71-4.6-1.29-2.71-1.54-2.6-4.72-1.53-29.83-.24.23-21.7h83.62a8.49,8.49,0,0,0,1.89-1.06,8.18,8.18,0,0,0,1.77-2.47V32.56L408.36,30l-2.13-.35-10.61-.47L395.5,9.21l-1.06-1.89-2.36-.47L232.87,6.73,230.51,8l-.71,1.29V29.37H215.89l-2.36.95L212.47,32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.3,162.18V149H212.69v13a4,4,0,0,1,1.7,1.26H408A3.77,3.77,0,0,1,409.3,162.18Z",
    style: {
      fill: "#e0e5ee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.62,20.15l-.45,36.61,38.18,7.5s.89-5.6.89-5.93-.33-6.27-.33-7.95-2.58-9-2.58-9l-4.7-7.72-8.29-7.5L356.52,23l-6.38-2-5.82-.67",
    style: {
      fill: "#e8ebee"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.5,
    y: 52.1,
    width: 15.14,
    height: 69.15,
    style: {
      fill: "#e8ebee"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.08,
    y: 75.01,
    width: 15.46,
    height: 46.25,
    style: {
      fill: "#e8ebee"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.76,
    y: 97.47,
    width: 15.57,
    height: 24.13,
    style: {
      fill: "#e8ebee"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,122.45h31.19a.48.48,0,0,0,.18,0,.58.58,0,0,0,.18,0h46.41a.6.6,0,1,0,0-1.2h-2.33a.54.54,0,0,0,.05-.22V97.93c0-.91-1.33-1.23-2.46-1.23H302.44c-1.13,0-2.46.32-2.46,1.23v23.18a.7.7,0,0,0,0,.14H289.38V75.93c0-1-1.08-1.85-2.46-1.85H274.68c-1.37,0-2.45.81-2.45,1.85v45.32H261.84V53.59a2.46,2.46,0,0,0-2.46-2.46H247.15a2.46,2.46,0,0,0-2.46,2.46v67.66h-3.23a.6.6,0,1,0,0,1.2Zm59.72-1.34v-23a3.25,3.25,0,0,1,1.26-.21h12.24a3.25,3.25,0,0,1,1.26.21V121a.54.54,0,0,0,0,.22H301.15A.35.35,0,0,0,301.18,121.11ZM273.43,75.93c0-.26.49-.65,1.25-.65h12.24c.77,0,1.26.39,1.26.65v45.32H273.43ZM245.89,53.59a1.25,1.25,0,0,1,1.26-1.26h12.23a1.25,1.25,0,0,1,1.26,1.26v67.66H245.89Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,93.21a36.89,36.89,0,0,0,35.78-28.14.59.59,0,0,0,.41-.46.58.58,0,0,0-.18-.53,36.8,36.8,0,0,0-36-44.53c-.81,0-1.61,0-2.41.09a.59.59,0,0,0-1.06.08,36.83,36.83,0,0,0,3.47,73.49Zm0-1.2a35.52,35.52,0,0,1-26.48-11.83l23.75-22.32,37.32,7.06A35.7,35.7,0,0,1,342.09,92Zm35.63-35.63a35.78,35.78,0,0,1-.77,7.37l-37.17-7V20.84c.76-.05,1.53-.09,2.31-.09A35.67,35.67,0,0,1,377.72,56.38ZM338.57,20.93V57L314.82,79.27a35.59,35.59,0,0,1,23.75-58.34Z",
    style: {
      fill: "#d6ddeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.91,28.64h-9.75V10a3.62,3.62,0,0,0-3.61-3.62H232.82A3.63,3.63,0,0,0,229.2,10V28.64H216.1a4.62,4.62,0,0,0-4.61,4.62V159.55a4.62,4.62,0,0,0,4.61,4.62H298v21H270a8.56,8.56,0,0,0,0,17.12h82a8.56,8.56,0,0,0,0-17.12H323.46v-21h82.45a4.62,4.62,0,0,0,4.61-4.62V33.26A4.62,4.62,0,0,0,405.91,28.64ZM230.4,10a2.43,2.43,0,0,1,2.42-2.42H392.55A2.42,2.42,0,0,1,395,10V132.82a2.41,2.41,0,0,1-2.41,2.41H232.82a2.42,2.42,0,0,1-2.42-2.41ZM216.1,29.84h13.1v103a3.62,3.62,0,0,0,3.62,3.61H392.55a3.61,3.61,0,0,0,3.61-3.61v-103h9.75a3.42,3.42,0,0,1,3.41,3.42V147.78H212.69V33.26A3.42,3.42,0,0,1,216.1,29.84ZM359.35,193.77a7.37,7.37,0,0,1-7.36,7.36H270a7.37,7.37,0,0,1,0-14.73h82A7.37,7.37,0,0,1,359.35,193.77Zm-37.09-8.56H299.18v-21h23.08ZM405.91,163H216.1a3.42,3.42,0,0,1-3.41-3.42V149H409.32v10.59A3.42,3.42,0,0,1,405.91,163Z",
    style: {
      fill: "#d6ddeb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.c4de3ef6cc786fa41f1b2319d00b62d6.svg";
export { ForwardRef as ReactComponent };